import { useState, useCallback } from "react";
import axios from "../customAxios";

/**
 * @typedef {object} NestedCommune
 * @property {number} id
 * @property {string} name
 * @property {string} system_name
 */

/**
 * @typedef {object} Region
 * @property {number} id
 * @property {string} name
 * @property {Array<NestedCommune>} communes
 */

/**
 * Custom Hook to fetch and manage hierarchical regional data.
 *
 * @returns {{
 *   regions: Array<Region>,
 *   loadingRegions: boolean,
 *   errorRegions: string | null,
 *   fetchRegions: (countryIso2?: string) => Promise<void>
 * }}
 */
export function useRegions() {
  const [regions, setRegions] = useState([]);
  const [loadingRegions, setLoadingRegions] = useState(false);
  const [errorRegions, setErrorRegions] = useState(null);

  const fetchRegions = useCallback(async (countryIso2 = "CL") => {
    setLoadingRegions(true);
    setErrorRegions(null);
    try {
      const { data } = await axios.get(
        `countries/regions/${countryIso2}/nested/`,
      );
      setRegions(data);
    } catch (error) {
      console.error(`Error fetching nested regions for ${countryIso2}:`, error);
      setErrorRegions("Error al cargar la estructura geográfica");
    } finally {
      setLoadingRegions(false);
    }
  }, []);

  return {
    regions,
    loadingRegions,
    errorRegions,
    fetchRegions,
  };
}
